import React from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Routes from './Routes';

const AppContainer = styled(Container)`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  overflow-y: auto;
`;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContainer fluid id="scrollable">
        <Routes />
      </AppContainer>
    </QueryClientProvider>
  );
}

export default App;
